const pages = {
    about: [
        {
            title: 'Organizing Committee',
            href: '/committee',
        },
    ],
    program: [
        {
            title: 'Workshop',
            href: '/workshop',
        },
        {
            title: 'Symposium',
            href: '/symposium',
        },
    ],
    submission: [
        {
            title: 'Abstract Submission',
            href: '/abstract-submission',
        },
    ],
    gallery: [
        {
            title: 'Gallery',
            href: '/gallery',
        },
    ],
};

export default pages;
